module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Karl Schroeder\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("KARL SCHROEDER lives in Toronto, Ontario")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mNG68/tc-custom/9781429938051.jpg?1718858493264",
      "alt": "This image is the cover for the book Sun of Suns, Virga"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sun of Suns, Virga\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A young man seeks vengeance against the man who killed his parents in this action-packed science fiction thriller series opener.")]), _c('br'), _c('br'), _vm._v("It is the distant future. The world known as Virga is a fullerene balloon three thousand kilometers in diameter, filled with air, water, and aimlessly floating chunks of rock. The humans who live in this vast environment must build their own fusion suns and “towns” that are in the shape of enormous wood and rope wheels that are spun for gravity."), _c('br'), _c('br'), _vm._v("Young, fit, bitter, and friendless, Hayden Griffin is a very dangerous man. He’s come to the city of Rush in the nation of Slipstream with one thing in mind: to take murderous revenge for the deaths of his parents six years ago. His target is Admiral Chaison Fanning, head of the fleet of Slipstream, which conquered Hayden’s nation of Aerie years ago. And the fact that Hayden’s spent his adolescence living with pirates doesn’t bode well for Fanning’s chances . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0